import React, { useEffect, useRef } from "react";
import { BrowserMultiFormatReader, NotFoundException } from "@zxing/library";

const Scanner = ({ onScan }) => {
  const videoRef = useRef(null);
  const codeReader = useRef(new BrowserMultiFormatReader());

  useEffect(() => {
    let isMounted = true;

    const startScanner = async () => {
      try {
        await codeReader.current.decodeFromConstraints(
          {
            audio: false,
            video: {
              facingMode: { ideal: "environment" },
              width: { ideal: 1280 },
              height: { ideal: 720 },
            }
          },
          videoRef.current,
          (result, err) => {
            if (!isMounted) return;

            if (result) {
              onScan(result.getText());
            }
            if (err && !(err instanceof NotFoundException)) {
              console.warn(err);
            }
          }
        );
      } catch (error) {
        console.error("Scanner error:", error);
      }
    };

    startScanner();

    return () => {
      isMounted = false;
      codeReader.current.reset();
    };
  }, [onScan]);

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{position : "relative"}}>
        <video
          ref={videoRef}
          style={{ width: "100%", borderRadius: "8px" }}
        />

        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "30vw",
            maxWidth: "120px",
            aspectRatio: "1 / 1",
            transform: "translate(-50%, -50%)",
            border: "3px dashed #1976d2",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Scanner;
